// Insira esse arquivo em javascripts/pages

import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Navigation, Pagination]);

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { setProducts } from '../components/utilities';
import InfinityScroll from '../components/infinityScroll';

const Blog = {
  setMansory: function() {
    var grid = document.querySelector('.grid');
    var msnry;

    imagesLoaded(grid, function() {
      msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
      });

      msnry.layout();
    });
  },

  init: function () {
    Blog.setMansory();
    InfinityScroll.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Blog.init();
});
